import { inject, Injectable } from '@angular/core';
import { AyaControllerApiService } from '@lx/shared/api';
import { getLocale } from '@lx/shared/i18n';
import { getCompanyHeader } from '@lx/shared/tokens';
import { map } from 'rxjs';
import { Memoize } from '@lx/shared/utils-http';

@Injectable({
  providedIn: 'root',
})
export class AyaLanguageService {
  private readonly locale = getLocale();
  private readonly companyHeader = getCompanyHeader();
  private readonly ayaService = inject(AyaControllerApiService);

  @Memoize({ tags: ['getLanguages'] })
  getLanguages() {
    return this.ayaService.getAyaLanguages(this.locale, this.companyHeader).pipe(map(({ languages }) => languages));
  }
}
